// import { fontsFaces } from './fonts'

export { GlobalStyles } from './global'
export { default as fonts } from './fonts'
export { default as colors } from './colors'
export { default as sizes, breakpoints } from './sizes'
export { default as textStyles } from './textStyles'
export { default as zIndexes } from './zindexes'

export { themesKey, themes } from './themes'

export { pxToRem, mq } from './mixins'
